var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M571.332 888.009H411.863V511.952h-79.695V382.4h79.695v-77.796c0-105.734 44.956-168.612 172.811-168.612h106.458v129.616h-66.53c-49.776 0-53.044 18.12-53.044 51.902l-.212 64.885h120.487l-14.097 129.552H571.349v376.057z"
  })));
};
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "b08a54e204d90f7b8bab3940eab5154c.svg";